/*
 * The country a VAT number belongs to, from its prefix: FR40356000000 → FR.
 * A tax id printed on a receipt is the one fact about the supplier that names
 * its country when the address does not.
 *
 * VAT prefixes are not all ISO codes: Greece files as EL, Northern Ireland as
 * XI (post-Brexit goods), Switzerland as CHE. Everything else is the ISO 3166-1
 * alpha-2 code. Only prefixes of countries with a VAT (or equivalent) number
 * are recognised, so "CVR 12345678" or "SIRET 356…" is not misread.
 *
 *   countryFromVatNumber('fr 40 356 000 000') → 'FR'
 *   countryFromVatNumber('EL123456789')        → 'GR'
 *   countryFromVatNumber('12345678')           → null   (no prefix: unknown)
 */

const PREFIX_TO_COUNTRY = {
    AT: 'AT', BE: 'BE', BG: 'BG', CY: 'CY', CZ: 'CZ', DE: 'DE', DK: 'DK', EE: 'EE',
    EL: 'GR', ES: 'ES', FI: 'FI', FR: 'FR', HR: 'HR', HU: 'HU', IE: 'IE', IT: 'IT',
    LT: 'LT', LU: 'LU', LV: 'LV', MT: 'MT', NL: 'NL', PL: 'PL', PT: 'PT', RO: 'RO',
    SE: 'SE', SI: 'SI', SK: 'SK', XI: 'GB',
    // Outside the EU, but their numbers carry the prefix the same way.
    GB: 'GB', NO: 'NO', CHE: 'CH'
};

/** The ISO 3166-1 alpha-2 country of a VAT number's prefix, or null when it has none we know. */
export const countryFromVatNumber = (taxId) => {
    const compact = String(taxId ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const match = compact.match(/^(CHE|[A-Z]{2})([A-Z0-9]{2,13})$/);
    if (!match) return null;
    // A number has digits; "DE" + "NMARK" is a word, not a VAT number.
    if (!/\d/.test(match[2])) return null;
    return PREFIX_TO_COUNTRY[match[1]] ?? null;
};

export default countryFromVatNumber
